import store from '@/store'

export default async (to, from, next) => {
    try {
        await store.dispatch('fetchUser');
    } catch (e) { }

    if (!store.getters.user) {
        next({ name: 'login' })
    } else if (store.getters.user.role !== 'admin') {
        next({ name: 'Dashboard' })
    } else {
        next()
    }
}


// WEBPACK FOOTER //
// ./src/middleware/admin.js